import { LoadingSpinner } from '@/components/LoadingSpinner';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const EmployeesContainer = lazy(() =>
  import('@features/employees/components/EmployeesContainer').then((module) => ({
    default: module.EmployeesContainer,
  }))
);

export const Route = createFileRoute('/_auth/employees')({ component: EmployeesComponent });

function EmployeesComponent() {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<LoadingSpinner message={t('common.splash.loading')} />}>
      <EmployeesContainer />
    </Suspense>
  );
}
